module.exports = __webpack_public_path__ + "img/bg-strength-3.790a7759.jpg";